import styled from 'styled-components';
import { Scrollbar } from '@ann/web-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  width: 100%;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  gap: 28px;
`;

export const FirstContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  text-align: center;
`;

export const AgentIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: ${(props) => props.theme.colors.primaryDarker || '#001740'};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.colors.white};
  font-size: 12px;
  font-weight: 700;
`;

export const ModelRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;

export const TooltipTrigger = styled.span`
  display: inline-flex;
`;

export const ButtonMenuTrigger = styled.span`
  display: inline-flex;
  flex-shrink: 0;

  & > .conversation-header-actions > button > span > svg{
    height: 12px;
    width: auto;
  }
`;

export const SecondContainer = styled.div`
  min-height: 80px;
  width: 100%;
  max-width: 750px;
    
  & > div {
    z-index: 1;
    position: relative;  
  } 
`;

export const ThirdContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 12px;
  width: 100%;
  max-width: 750px;
  min-width: 0;
  justify-content: center;

  /* Override @ann/web-components Tooltip Root: it uses display:inline-flex + width:fit-content
     which breaks flex layout. Force each starter (or Tooltip wrapper) to participate in flex. */
  & > * {
    display: flex !important;
    flex: 1 1 107px !important;
    min-width: 0 !important;
    max-width: 100% !important;
    width: 100% !important;
  }
`;

export const StarterQuestion = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 107px;
  min-width: 0;
  max-width: 100%;
  padding: 12px 16px;
  background: ${(props) => props.theme.colors.white};
  border: 1px solid ${(props) => props.theme.colors.border || '#D9D9D9'};
  border-radius: 8px;
  cursor: pointer;
  text-align: center;
  min-height: 84px;
  height: 84px;
  max-height: 84px;
`;

export const ConversationHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  gap: 24px;
  width: 100%;
  max-width: 750px;
`;

export const ConversationHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-width: 0;
  padding: 8px 12px;
  max-height: 43px;
`;

export const ConversationHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex-shrink: 0;
`;

export const ConversationHeaderCenter = styled.div`
  flex: 1;
  min-width: 0;
  min-height: 40px;
  margin: 0 8px;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  background: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.6);
`;

export const ConversationHeaderCenterPlaceholder = styled.span`
  font-size: 13px;
  color: ${(props) => props.theme.colors?.grey ?? 'rgba(0, 0, 0, 0.4)'};
  filter: blur(8px);
  -webkit-filter: blur(8px);
  pointer-events: none;
  user-select: none;
  white-space: nowrap;
  letter-spacing: 3px;
`;

export const ConversationHeaderTitleWrap = styled.span`
  white-space: nowrap;

  & > span: first-child {
    font-weight: 600;
  }
`;

export const ConversationHeaderModelWrap = styled.span`
  white-space: nowrap;
`;

export const HeaderRightGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const ClickableContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const DocumentButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  max-width: 750px;
`;


export const MessagesList = styled(Scrollbar).attrs((props) => ({
  size: "small",
  display: "flex",
  padding: "8px",
  parentRef: props.parentRef,
}))`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  max-width: 750px;
  flex: 1;
  min-height: 0;
  overscroll-behavior: none;
  overscroll-behavior-y: none;
`;

export const MessageRow = styled.div`
  display: flex;
  flex-direction: column;
  align-self: ${(props) => (props.$isUser ? "flex-end" : "flex-start")};
  max-width: ${(props) => (props.$isUser ? "85%" : "100%")};
  width: ${(props) => (props.$isUser ? "auto" : "100%")};
  padding: 8px 4px;
`;

export const MessageBubbleActions = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: auto;
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  transition: max-height 0.2s ease, opacity 0.15s ease;
  cursor: default;
`;

export const MessageBubbleActionIcon = styled.div`
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const MessageBubble = styled.div`
  padding: 16px 12px;
  border-radius: 8px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: ${(props) =>
    props.$isUser
      ? "radial-gradient(77.51% 157.3% at 18.46% 91.07%, #E5F8FF 0%, #FFFFFF 80.17%)"
      : "transparent"};
  box-shadow: ${(props) =>
    props.$isUser ? "2px 2px 8px 1px #0000000F" : "none"};
  transition: box-shadow 0.15s ease;

  ${(props) =>
    props.$isUser
      ? `
    &:hover ${MessageBubbleActions} {
      max-height: 40px;
      opacity: 1;
    }
    ${MessageBubbleActions} {
      align-self: flex-start;
    }
  `
      : ""}

  ${(props) =>
    !props.$isUser
      ? `
    &:hover {
      box-shadow: 2px 2px 8px 1px #0000000F;
    }
    &:hover ${MessageBubbleActions} {
      max-height: 40px;
      opacity: 1;
    }
    ${MessageBubbleActions} {
      align-self: flex-start;
    }
  `
      : ""}
`;

export const MessageText = styled.span`
  display: inline;
  white-space: inherit;
  font-size: ${(props) => props.theme.fontSize?.base || props.theme.fonts?.size?.b1 || "14px"};
  font-weight: 400;
  line-height: 1.5;
  font-family: ${(props) => props.theme.fonts?.family?.inter || "inherit"};
  color: inherit;

  .highlight-current,
  .highlight-other {
    display: inline !important;
    padding: 0;
    margin: 0;
    color: inherit;
    font: inherit;
  }

  .highlight-current {
    background-color: #ED6C0266;
  }

  .highlight-other {
    background-color: #2173FF66;
  }
`;

export const ComponentLabel = styled.div`
  background: ${(props) => props.theme.colors.info || '#52c41a'};
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  margin-bottom: 8px;
  margin-top: 8px;
  width: fit-content;
  display: block;
`;
